import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="phone-modal"
export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.dataset.complete = true;
    }, 50);
  }

  close() {
    this.element.dataset.complete = false;
    setTimeout(() => {
      this.element.parentElement.removeAttribute("src");
    }, 300)
  }
}
